import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoggerModule } from 'ngx-logger';
import { PetszelSharedModule, SharedLibraryService, sharedLibraryConfigProvider } from 'projects/petszel-shared/src/public-api';
import { appConfig } from '../owner.config';
import { PetArticlePageComponent } from './pages/pet-article-page/pet-article-page.component';
import { ContentfulService } from './service/contentful.service';
import { AuthGuardService } from './service/authentication-guard.service';
import { AuthInterceptor } from './service/auth-interceptor';
import { EmailResetComponent } from './pages/email-reset/email-reset.component';
import { TermsAndConditionsModalComponent } from './components/terms-and-conditions-modal/terms-and-conditions-modal.component';
import { StoreModule } from "@ngrx/store";
import { petsReducer } from "./shared-store/pet/pet.reducer";
import { EffectsModule } from "@ngrx/effects";
import { PetEffects } from "./shared-store/pet/pet.effects";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { ShelterEffects } from "./shared-store/shelter/shelter.effects";
import { ownerReducer } from "./shared-store/owner/owner.reducer";
import { OwnerEffects } from "./shared-store/owner/owner.effects";
import { loadStateReducer } from "./shared-store/app-state.reducer";
import { selectedVariablesReducer } from "./shared-store/selected-variables/selected-variables.reducer";
import { featureFlagTeleAdviceReducer, featureFlagHillsPostAdoptionDTCReducer, featureFlagInsuranceReducer } from "./shared-store/feature-flags/feature-flags.reducer";
import { FeatureFlagsEffects } from "./shared-store/feature-flags/feature-flags.effects";
import { sheltersExtendedReducer } from "./shared-store/shelter/shelter-extended.reducer";
import { SelectedVariablesEffects } from "./shared-store/selected-variables/selected-variables-effects";
import { ErrorTrackingInterceptor } from './pages/survey/error-tracking.interceptor';
import { ownerEnvironment } from '../environments/environment';
import { NoPetComponent } from './pages/no-pet/no-pet.component';
import { authReducer } from './shared-store/auth/auth.reducer';
import { AuthEffects } from './shared-store/auth/auth.effects';
import { CtaTrackingDirective } from './service/cta-tracking.directive';
import { IconComponent } from 'projects/petszel-shared/src/lib/design-system/components/icon/icon.component';


@NgModule({
  declarations: [
    AppComponent,
    PetArticlePageComponent,
    EmailResetComponent,
    TermsAndConditionsModalComponent,
    NoPetComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    CtaTrackingDirective,
    IconComponent,
    CommonModule,
    PetszelSharedModule,
    LoggerModule.forRoot({
      level: ownerEnvironment.logger.level,
      serverLogLevel: ownerEnvironment.logger.serverLogLevel,
      disableConsoleLogging: ownerEnvironment.logger.disableConsoleLogging
    }),
    StoreModule.forRoot({
      auth: authReducer,
      pets: petsReducer,
      sheltersExtended: sheltersExtendedReducer,
      owner: ownerReducer,
      loadState: loadStateReducer,
      selectedVariables: selectedVariablesReducer,
      featureFlagTeleAdvice: featureFlagTeleAdviceReducer,
      featureFlagHillsPostAdoptionDTC: featureFlagHillsPostAdoptionDTCReducer,
      featureFlagInsurance: featureFlagInsuranceReducer,
    }),
    EffectsModule.forRoot([
      AuthEffects,
      PetEffects,
      ShelterEffects,
      OwnerEffects,
      FeatureFlagsEffects,
      SelectedVariablesEffects
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      connectInZone: true
    })], providers: [
    {
      provide: 'appConfig',
      useValue: appConfig,
    },
    ContentfulService,
    AuthGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    sharedLibraryConfigProvider,
    SharedLibraryService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorTrackingInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi())
  ] })
export class AppModule {}
